import { IonInput, IonItem, IonLabel } from "@ionic/react"
import React from "react"

interface Props {
  value: string
  onChange: (value: string) => void
}

const FormMobile: React.FC<Props> = (props) => {
  const update = (c: string): void => {
    props.onChange(c.replace(/[^\d-+]/, ''))
  }

  return (
    <IonItem>
      <IonLabel position="floating">Mobil Nummer</IonLabel>
      <IonInput
        inputmode={'tel'}
        value={props.value}
        onIonChange={e => update((e.target as HTMLInputElement).value)}
      />
    </IonItem>
  )
}

export default FormMobile
